module.exports = __webpack_public_path__ + "static/badge-534f1001dbfbf2f1f6f9be2c3fa0953b.png";